import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import 'bootstrap/scss/bootstrap.scss'
import 'react-toastify/dist/ReactToastify.css'

import { QueryClientProvider } from '@tanstack/react-query'
import './assets/scss/main.scss'
import reportWebVitals from './reportWebVitals'
import { client } from './query/client'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
